<template>
  <ion-page>
    <!--simulate iontoolbar margin/padding stuff-->
    <div class="content-gap"></div><!--:style="{height: isIos ? '100px' : '50px'}"-->

    <ion-progress-bar  type="indeterminate" v-if="syncActive && currentProgress == 0"></ion-progress-bar>
    <ion-progress-bar color="primary" v-if="syncActive && currentProgress > 0"
                      :value="currentProgress"></ion-progress-bar>

    <small class="ion-padding checking-data" v-if="syncActive && downloadSize === 0">{{ wordings[currentLanguage].CHECKING_DATA }}</small>
    <small class="ion-padding checking-data" v-if="syncActive && downloadSize && downloadLabel">{{ downloadLabelText }}
      {{ downloadSize }} {{ downloadLabel }} - {{ (currentProgress * 100).toFixed(2) }}%</small>

    <banner direction="horizontal" position="top"></banner>

    <banner position="fullscreen"></banner>
    <slot></slot>
    <banner  v-if="this.$route.name!='Videoroom' && this.$route.name!='Meetings Manager'" direction="vertical" position="bottom"></banner>
    <!--ion-footer v-if="this.$route.name!='Videoroom' && isSociety" style="background: #0E5F99 !important;">
      <ion-toolbar class="docu-footer"  >

        <div class="footer-container" style="background: #0E5F99">
          <a class="button button-clear button-positive footer-link" href="https://www.facebook.com/ISPAD.org" target="_blank" style="font-size: 2rem; margin: 0 10px">
            <i class="icon ion-social-facebook" style="color:#E8DF45;"></i>

          </a>
          <a class="button button-clear button-positive footer-link" href="https://twitter.com/ispad_org" target="_blank" style="font-size: 2rem; margin: 0 10px">
            <i class="icon ion-social-twitter" style="color:#E8DF45;"></i>

          </a>
          <a class="button button-clear button-positive footer-link" href="https://www.linkedin.com/company/international-society-for-pediatric-and-adolescent-diabetes-ispad-" target="_blank" style="font-size: 2rem; margin: 0 10px">
            <i class="icon ion-social-linkedin" style="color:#E8DF45;"></i>

          </a>

        </div>
      </ion-toolbar>
    </ion-footer-->
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonFooter,
  IonToolbar,
  IonProgressBar,
} from "@ionic/vue";
import {defineComponent} from "vue";
import {mapState, mapGetters} from "vuex";
import {isPlatform, modalController} from '@ionic/vue';
import PdfModal from "@/views/Industry/PdfModal";

const config = require('@/config')
import {addIcons} from "ionicons";
import {personCircleOutline, logoRss} from "ionicons/icons";
import {logOutOutline} from "ionicons/icons";
import {logInOutline} from "ionicons/icons";

addIcons({"person-circle-outline": personCircleOutline});
addIcons({"log-out-outline": logOutOutline})
addIcons({"log-in-outline": logInOutline})
addIcons({"logo-rss": logoRss})

export default defineComponent({
  name: "App",
  components: {
    IonPage,
    IonFooter,
    IonToolbar,
    IonProgressBar,
  },
  data() {
    return {

      isDesktop: null,
      isIos:null,
      title: config.full_name,
      
    }
  },
  mounted() {
  },
  methods: {


    async handleFile() {
      let link = ""
      let viewerLink =  link
      console.log(viewerLink)

      this.modal = await modalController
          .create({
            component: PdfModal,
            cssClass: 'pdf-modal',
            componentProps: {
              title: "Privacy policy",
              link: viewerLink
            },
          })
      return this.modal.present();
    },


  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters('currentConference', ['isSociety']),
    ...mapState('sync', ['updateFinished', 'syncActive', 'downloadSize', 'downloadLabel', 'currentProgress','downloadLabelText']),
     ...mapState('wordings',['wordings', 'currentLanguage']),
  },
  async created() {
    this.isDesktop = isPlatform('desktop');
    this.isIos = isPlatform('ios')
  },

   watch: {
    '$route': {
      immediate: true,
      async handler() {

       
      }
    }
  }





});
</script>
<style lang="scss">

ion-content {
  //--padding-start: env(safe-area-inset-left); /* Apply safe area */
  //--padding-end: env(safe-area-inset-right);
}

.docu-footer {
  background: #0E5F99 !important;
  border-top: 1px solid lightgrey;
  --padding-start:0;
  --padding-end:0;
  --padding-top:0;
  --padding-bottom:0;

  .footer-container {
    text-align: center;
    text-decoration: none;



    .footer-link {
      color: #274564 !important;
      font-weight: 400;
      font-size: 0.7rem;
      text-decoration: none;
    }
  }

}

 ion-progress-bar {
    --background: #274564 ;
    --buffer-background: #274564 ;
  }



</style>
